import { Alert } from "@mui/material";
import { classes } from "common/theme/theme";
import { FormikDimensionedNumberInput } from "common/components/FormikDimensionedNumberInput";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";

export const NumberInputWithUsageNote: React.FC<{
  className?: string;
  numberInputProps: React.ComponentProps<typeof FormikDimensionedNumberInput>;
  tooltipProps: React.ComponentProps<typeof Alert>;
}> = ({ className, numberInputProps, tooltipProps }) => {
  const effectiveTooltipProps = {
    severity: "info" as const,
    icon: <InfoIcon />,
    ...tooltipProps,
  };

  return (
    <div className={classes("grid grid-cols-2 gap-4 items-center", className)}>
      <FormikDimensionedNumberInput {...numberInputProps} />
      <Alert {...effectiveTooltipProps} />
    </div>
  );
};
